document.addEventListener("DOMContentLoaded", function () {
	// Initialize all reputation testimonials blocks
	const testimonialsContainers = document.querySelectorAll(
		".wp-block-mr-blocks-reputation-testimonials",
	);

	testimonialsContainers.forEach(function (container) {
		const widgetUrl = container.dataset.widgetUrl;
		const loadingElement = container.querySelector(".testimonials-loading");
		const errorElement = container.querySelector(".testimonials-error");

		if (!widgetUrl) {
			console.error("No widget URL found for reputation testimonials");
			if (loadingElement) loadingElement.style.display = "none";
			if (errorElement) {
				errorElement.style.display = "block";
				errorElement.textContent = "Widget URL is required";
			}
			return;
		}

		// Get AJAX data - try multiple sources
		let ajaxData = null;

		// Try window.mrBlocksReputation first
		if (window.mrBlocksReputation) {
			ajaxData = window.mrBlocksReputation;
		}
		// Try localized script data
		else if (typeof mrBlocksReputation !== "undefined") {
			ajaxData = mrBlocksReputation;
		}

		if (!ajaxData || !ajaxData.ajax_url) {
			console.error(
				"AJAX data not found. Available data:",
				window.mrBlocksReputation,
				typeof mrBlocksReputation !== "undefined"
					? mrBlocksReputation
					: "undefined",
			);
			if (loadingElement) loadingElement.style.display = "none";
			if (errorElement) {
				errorElement.style.display = "block";
				errorElement.textContent =
					"Configuration error. Please check plugin setup.";
			}
			return;
		}

		console.log("Using AJAX data:", ajaxData);

		// Create form data
		const formData = new FormData();
		formData.append("action", "mr_fetch_reputation_testimonials");
		formData.append("widget_url", widgetUrl);
		formData.append("nonce", ajaxData.nonce);

		// Fetch testimonials
		fetch(ajaxData.ajax_url, {
			method: "POST",
			body: formData,
			credentials: "same-origin",
		})
			.then((response) => {
				console.log("Response status:", response.status);
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				console.log("AJAX response:", data);

				if (loadingElement) loadingElement.style.display = "none";

				if (data.success && data.data && data.data.testimonials) {
					const testimonials = data.data.testimonials;

					if (testimonials.length > 0) {
						console.log(
							`Fetched ${testimonials.length} testimonials, rendering...`,
						);
						renderTestimonials(container, testimonials);
						// Add small delay to ensure DOM is updated before initializing carousel
						setTimeout(() => {
							initializeCarousel(container);
						}, 100);
					} else {
						// Try to display raw HTML if no testimonials parsed
						if (data.data.raw_html) {
							console.log("No testimonials parsed, displaying raw HTML");
							const carouselElement = container.querySelector(
								".mr-testimonials-carousel",
							);
							if (carouselElement) {
								carouselElement.innerHTML = data.data.raw_html;
								// Try to initialize carousel on raw HTML as well
								setTimeout(() => {
									initializeCarousel(container);
								}, 100);
							}
						} else {
							showError(container, "No testimonials found in the widget.");
						}
					}
				} else {
					const errorMessage =
						data.data && data.data.message
							? data.data.message
							: "Failed to load testimonials";
					console.error("Error from server:", errorMessage);
					showError(container, errorMessage);
				}
			})
			.catch((error) => {
				console.error("Fetch error:", error);
				if (loadingElement) loadingElement.style.display = "none";
				showError(container, "Failed to load testimonials: " + error.message);
			});
	});

	function showError(container, message) {
		const errorElement = container.querySelector(".testimonials-error");
		if (errorElement) {
			errorElement.style.display = "block";
			errorElement.textContent = message;
		}
	}

	function renderTestimonials(container, testimonials) {
		console.log("Rendering testimonials:", testimonials);

		// Get settings from data attributes
		const showDate = container.dataset.showDate === "true";
		const showPlatform = container.dataset.showPlatform === "true";

		console.log("Show date:", showDate, "Show platform:", showPlatform);

		// Find the carousel container
		const carouselElement = container.querySelector(
			".mr-testimonials-carousel",
		);
		if (!carouselElement) {
			console.error("No .mr-testimonials-carousel found");
			return;
		}

		const splideElement = carouselElement.querySelector(".splide");
		if (!splideElement) {
			console.error("No .splide element found");
			return;
		}

		// Destroy existing Splide instance if it exists
		if (splideElement.splide) {
			try {
				splideElement.splide.destroy();
				console.log("Destroyed existing Splide instance");
			} catch (error) {
				console.warn("Error destroying Splide instance:", error);
			}
		}

		const splideList = carouselElement.querySelector(".splide__list");
		if (!splideList) {
			console.error("No .splide__list found");
			return;
		}

		// Clear existing content (remove loading element)
		splideList.innerHTML = "";

		testimonials.forEach(function (testimonial, index) {
			const slide = document.createElement("li");
			slide.className = "splide__slide";

			const stars = generateStars(testimonial.rating || 5);

			// Build platform icon HTML if available and showPlatform is true
			const platformIcon =
				showPlatform && testimonial.icon_url
					? `<img src="${escapeHtml(testimonial.icon_url)}" alt="${escapeHtml(
							testimonial.platform || "Platform",
					  )}" class="platform-icon" width="20" height="20" style="margin-right: 8px; border-radius: 3px; vertical-align: middle;">`
					: "";

			// Build the author section
			const authorDisplay =
				showPlatform && platformIcon
					? `${platformIcon}${escapeHtml(testimonial.author || "Anonymous")}`
					: escapeHtml(testimonial.author || "Anonymous");

			// Build date section only if showDate is true
			const dateDisplay =
				showDate && testimonial.date
					? `<div class="testimonial-date">${escapeHtml(
							testimonial.date,
					  )}</div>`
					: "";

			slide.innerHTML = `
				<div class="testimonial-card">
					<div class="testimonial-rating">${stars}</div>
					<div class="testimonial-text">"${escapeHtml(
						testimonial.text || "Great service!",
					)}"</div>
					<div class="testimonial-meta">
						<div class="testimonial-author">
							${authorDisplay}
						</div>
						${dateDisplay}
					</div>
				</div>
			`;

			splideList.appendChild(slide);
		});

		// Show the carousel
		carouselElement.style.display = "block";

		console.log(`Rendered ${testimonials.length} testimonials`);
	}

	function generateStars(rating) {
		const fullStars = Math.floor(rating);
		const hasHalfStar = rating % 1 !== 0;
		let starsHtml = "";

		for (let i = 0; i < fullStars; i++) {
			starsHtml += '<span class="star filled">★</span>';
		}

		if (hasHalfStar) {
			starsHtml += '<span class="star half">☆</span>';
		}

		const emptyStars = 5 - Math.ceil(rating);
		for (let i = 0; i < emptyStars; i++) {
			starsHtml += '<span class="star empty">☆</span>';
		}

		return starsHtml;
	}

	function escapeHtml(text) {
		const div = document.createElement("div");
		div.textContent = text;
		return div.innerHTML;
	}

	function initializeCarousel(container) {
		// Small delay to ensure DOM is fully updated after testimonials rendering
		setTimeout(() => {
			// Wait for Splide to be available
			const waitForSplide = setInterval(function () {
				if (typeof Splide !== "undefined") {
					clearInterval(waitForSplide);
					setupCarousel(container);
				}
			}, 100);

			// Stop waiting after 5 seconds
			setTimeout(function () {
				clearInterval(waitForSplide);
			}, 5000);
		}, 50);
	}

	function setupCarousel(container) {
		const splideElement = container.querySelector(".splide");
		if (!splideElement) {
			console.error("No .splide element found in setupCarousel");
			return;
		}

		const slides = splideElement.querySelectorAll(
			".splide__slide:not(.testimonials-loading-slide)",
		);
		console.log(`Found ${slides.length} testimonial slides for carousel setup`);

		if (slides.length === 0) {
			console.warn("No testimonial slides found, skipping carousel setup");
			return;
		}

		// Get configuration from data-splide attribute (set in save.js)
		let splideConfig = {};
		try {
			const configData = splideElement.getAttribute("data-splide");
			if (configData) {
				splideConfig = JSON.parse(configData);
				console.log("Parsed splide config from data attribute:", splideConfig);
			}
		} catch (error) {
			console.warn("Error parsing splide configuration:", error);
			splideConfig = {};
		}

		// Ensure we have valid perPage value
		const perPage = Math.max(1, parseInt(splideConfig.perPage) || 1);
		const gap = Math.max(0, parseInt(splideConfig.gap) || 20);

		console.log(
			`Setting up carousel with perPage: ${perPage}, gap: ${gap}, slides: ${slides.length}`,
		);

		// Default configuration
		const defaultConfig = {
			type: "loop",
			perPage: perPage,
			gap: gap,
			autoplay: splideConfig.autoplay || false,
			pauseOnHover: true,
			pauseOnFocus: true,
			easing: splideConfig.easing || "ease",
			arrows: splideConfig.arrows !== false,
			pagination: splideConfig.pagination !== false,
			rewind: false,
		};

		// Add responsive breakpoints with proper perPage handling
		defaultConfig.breakpoints = {
			1024: {
				perPage: Math.min(perPage, 2),
				gap: Math.min(gap, 20),
			},
			768: {
				perPage: 1,
				gap: Math.min(gap, 20),
			},
		};

		// Adjust config based on actual slide count
		if (slides.length <= perPage) {
			defaultConfig.type = "slide";
			defaultConfig.rewind = true;
			if (slides.length === 1) {
				defaultConfig.arrows = false;
				defaultConfig.pagination = false;
			}
		}

		console.log("Final Splide configuration:", defaultConfig);

		try {
			// Destroy any existing instance first
			if (splideElement.splide) {
				splideElement.splide.destroy();
			}

			const splide = new Splide(splideElement, defaultConfig);
			splide.mount();

			// Store the instance for potential cleanup
			splideElement.splide = splide;

			console.log(
				"Splide carousel initialized successfully with",
				slides.length,
				"slides",
			);
		} catch (error) {
			console.error("Error initializing Splide carousel:", error);
		}
	}
});
